import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query"
import { ApiResponse } from "@/shared/types/interface/api"
import { PostInquiryRequest, GetInterestResponse, PostInterestRequest, PostEntryFormRequest, PostUnrestrictedInquiryRequest } from "@/shared/types/type/user"
import {
  deleteHospitalFavoriteClient,
  getUserInterest,
  postEntryFormClient,
  postHospitalFavoriteClient,
  postUnrestrictedInquiry,
  postUserInquiry,
  postUserInterest,
} from "@/entities/user/api/user.client"

export const useMutationPostUserInterest = (options?: UseMutationOptions<ApiResponse<unknown>, Error, PostInterestRequest, unknown>) => {
  return useMutation<ApiResponse<unknown>, Error, PostInterestRequest>({
    mutationFn: postUserInterest,
    ...options,
  })
}

export const useQueryUserInterest = <TData>(options?: Omit<UseQueryOptions<ApiResponse<GetInterestResponse>, Error, TData>, "queryKey" | "queryFn">) => {
  return useQuery<ApiResponse<GetInterestResponse>, Error, TData>({
    queryKey: ["userInterest"],
    queryFn: getUserInterest,
    ...options,
  })
}

export const useMutationPostUserInquiry = (options?: UseMutationOptions<ApiResponse<unknown>, Error, PostInquiryRequest, unknown>) => {
  return useMutation<ApiResponse<unknown>, Error, PostInquiryRequest>({
    mutationFn: postUserInquiry,
    ...options,
  })
}

export const useMutationPostHospitalFavorite = (options?: UseMutationOptions<ApiResponse<unknown>, Error, number>) => {
  return useMutation<ApiResponse<unknown>, Error, number>({
    mutationFn: postHospitalFavoriteClient,
    ...options,
  })
}

export const useMutationDeleteHospitalFavorite = (options?: UseMutationOptions<ApiResponse<unknown>, Error, number>) => {
  return useMutation<ApiResponse<unknown>, Error, number>({
    mutationFn: deleteHospitalFavoriteClient,
    ...options,
  })
}

export const useMutationPostEntryForm = (options?: UseMutationOptions<ApiResponse<unknown>, Error, PostEntryFormRequest, unknown>) => {
  return useMutation<ApiResponse<unknown>, Error, PostEntryFormRequest>({
    mutationFn: postEntryFormClient,
    ...options,
  })
}

export const useMutationPostUnrestrictedInquiry = (options?: UseMutationOptions<ApiResponse<unknown>, Error, PostUnrestrictedInquiryRequest, unknown>) => {
  return useMutation<ApiResponse<unknown>, Error, PostUnrestrictedInquiryRequest>({
    mutationFn: postUnrestrictedInquiry,
    ...options,
  })
}
